import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createElementBlock("view", null, [
    _createVNode(_component_ion_card, { class: "margin-top-unset" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_header, { class: "label-block" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_title, {
              class: _normalizeClass(_ctx.getLabelClass())
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Definition in the renowned dictionary ", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          sizeXs: "4",
          sizeSm: "4",
          sizeMd: "3",
          sizeLg: "3",
          sizeXl: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card, {
              button: true,
              href: `https://dictionary.cambridge.org/dictionary/english/${_ctx.word.toLowerCase()}`,
              target: "_blank",
              class: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, { class: "display-flex ion-justify-content-center ion-padding" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                      src: "/assets/icon/cambridge.png",
                      alt: "Cambridge Dictionary",
                      class: "dictionary-logo-extra"
                    }, null, -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_col, {
          sizeXs: "4",
          sizeSm: "4",
          sizeMd: "3",
          sizeLg: "3",
          sizeXl: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card, {
              button: true,
              href: `https://www.merriam-webster.com/dictionary/${_ctx.word.toLowerCase()}`,
              target: "_blank",
              class: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, { class: "display-flex ion-justify-content-center ion-padding" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      src: "/assets/icon/merriam-webster.png",
                      alt: "Merriam Webster Dictionary",
                      class: "dictionary-logo-extra"
                    }, null, -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_col, {
          sizeXs: "4",
          sizeSm: "4",
          sizeMd: "3",
          sizeLg: "3",
          sizeXl: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card, {
              button: true,
              href: `https://www.oxfordlearnersdictionaries.com/definition/english/${_ctx.word
                        .toLowerCase()
                        .replace(' ', '-')}_1?q=${_ctx.word.toLowerCase().replace(' ', '+')}`,
              target: "_blank",
              class: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, { class: "display-flex ion-justify-content-center ion-padding" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("img", {
                      src: "/assets/icon/oxford.png",
                      alt: "Oxford Dictionary",
                      class: "dictionary-logo-extra"
                    }, null, -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}